module.exports = __webpack_public_path__ + "img/index-manual-step-1@3x.61ef37a8.png";